import { CURRENCIES } from '@weft/types';
import { values } from '@weft/utils';
import React from 'react';
import type { StyledTextField } from '../StyledTextField';
import { BaseSelect } from './BaseSelect';

type CurrenciesSelectProps = Omit<React.ComponentProps<typeof StyledTextField>, 'options'> & {
  textFieldProps?: React.ComponentProps<typeof StyledTextField>['inputProps'];
};

export const CurrenciesSelect = React.forwardRef<HTMLInputElement, CurrenciesSelectProps>((props, ref) => {
  return (
    <BaseSelect
      {...props}
      ref={ref}
      values={values(CURRENCIES)}
      label='Currency'
    />
  );
});